import React from 'react';
import { SymbolThesis } from '../../../ai/thesisEngine';

export function ConvictionTrendChart({ thesis }: { thesis: SymbolThesis }) {
  const points = [
    ...(thesis.history.slice(0, 4).reverse()),
    ...(thesis.current ? [{ conviction: thesis.current.conviction, thesisChange: thesis.current.thesisChange, timestamp: thesis.current.timestamp }] : []),
  ];
  if (points.length < 2) return null;

  const max = 100, min = 0, w = 140, h = 32, pad = 4;
  const xStep = (w - pad * 2) / (points.length - 1);

  const pts = points.map((p, i) => ({
    x: pad + i * xStep,
    y: h - pad - ((p.conviction - min) / (max - min)) * (h - pad * 2),
    conv: p.conviction,
    change: p.thesisChange,
  }));

  const pathD = pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ');
  const lastPt = pts[pts.length - 1];
  const lastColor = lastPt.conv >= 70 ? '#22C55E' : lastPt.conv >= 50 ? '#F59E0B' : '#EF4444';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 9, color: 'var(--blue-dim)', fontFamily: 'var(--mono)' }}>CONVICTION TREND</span>
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <path d={pathD} fill="none" stroke={lastColor} strokeWidth="1.5" strokeOpacity=".7" />
        {pts.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r="2.5"
            fill={p.change === 'invalidated' ? '#EF4444' : p.change === 'strengthened' ? '#22C55E' : lastColor}
            opacity={i === pts.length - 1 ? 1 : .5} />
        ))}
      </svg>
      <span style={{ fontSize: 10, fontFamily: 'var(--mono)', color: lastColor, fontWeight: 700 }}>
        {lastPt.conv}%
      </span>
    </div>
  );
}
